import { isInstantBookingLEHotelItem } from 'lib/checkout/checkoutUtils'
import { createSelector } from 'reselect'
import getPaymentScheduleAdjustmentAmount from './getPaymentScheduleAdjustmentAmount'

const getPaymentScheduleAdjustmentRequestInfo = createSelector(
  (state: App.State) => state.checkout.cart.existingOrder,
  (state: App.State) => state.checkout.cart.items,
  (state: App.State) => state.geo.currentCurrency,
  getPaymentScheduleAdjustmentAmount,
  (
    existingOrder,
    cartItems,
    currency,
    adjustmentAmount,
  ): App.Checkout.PaymentScheduleAdjustmentRequestInfo | null => {
    if (!existingOrder) {
      return null
    }

    const hotelItem = cartItems.find(isInstantBookingLEHotelItem)

    if (!hotelItem) {
      return null
    }

    const startDate = hotelItem.checkIn

    if (!startDate) {
      return null
    }

    const adjustedItem = {
      idItems: hotelItem.orderItemId ?? undefined,
      adjustmentAmount,
    }

    if (adjustedItem.idItems === undefined) {
      return null
    }

    // Get all accommodation items' check-in dates from the existing order
    // For the item being changed, use the new check-in date from the cart
    const allItemsCheckinDates = existingOrder.items
      ?.filter(item => item.reservation?.startDate)
      .map(item => ({
        id_items: item.id,
        checkin_date: item.id === adjustedItem.idItems ? startDate : item.reservation?.startDate ?? '',
      })) ?? []

    return {
      orderId: existingOrder.id,
      bookingInfo: {
        checkinDate: startDate,
        currency,
        idItems: adjustedItem.idItems,
        adjustmentAmount: adjustedItem.adjustmentAmount,
        allItemsCheckinDates: allItemsCheckinDates.length > 0 ? allItemsCheckinDates : undefined,
      },
    }
  },
)

export default getPaymentScheduleAdjustmentRequestInfo
